
import Menu from '../Menu'
import React, { useState, useEffect } from 'react';
import { useParams } from "react-router-dom";
import '../App.css'
//import myImage from './assets/sorting-arrows-100.png'; // Adjust the path as needed



const ShareAlarms = () => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const {orderby} = useParams();
    const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });

    // Sort data based on sortConfig
    const sortedData = [...data].sort((a, b) => {
        if (!sortConfig.key) return 0;

        // Handle string sorting for symb
        if (sortConfig.key === 'symb') {
            const aValue = (a[sortConfig.key] || '').toLowerCase();
            const bValue = (b[sortConfig.key] || '').toLowerCase();
            if (sortConfig.direction === 'asc') {
                return aValue.localeCompare(bValue);
            } else {
                return bValue.localeCompare(aValue);
            }
        }

        // Handle numeric sorting for procent, myprocbuy
        const aValue = parseFloat(a[sortConfig.key]) || 0;
        const bValue = parseFloat(b[sortConfig.key]) || 0;

        if (sortConfig.direction === 'asc') {
            return aValue - bValue;
        } else {
            return bValue - aValue;
        }
    });

    // Handle column header click for sorting
    const handleSort = (key) => {
        setSortConfig((prevConfig) => ({
            key,
            direction: prevConfig.key === key && prevConfig.direction === 'asc' ? 'desc' : 'asc'
        }));
    };

    // Get CSS class for sortable column header
    const getSortClass = (key) => {
        let className = 'sortable';
        if (sortConfig.key === key) {
            className += ' ' + sortConfig.direction;
        }
        return className;
    };


    const updateProcentAut = async () => {
        const userConfirmed = window.prompt("Are you sure you want to update ?",85);
        if (!userConfirmed) {
            return;
        }
        
        const mytoken=sessionStorage.getItem('google_token');
        var strBody={"procent":userConfirmed};
        var apiUrl = 'https://app64.heliohost.us/api/updateGenShares.php?operation=updateShareAlarmsProcent';
        fetch( apiUrl,{
            method:"POST",          
            headers:{
                "Content-Type": "application/json",
                "AuthCode" : mytoken
            },
            body:JSON.stringify(strBody)
        })
            .then((response) => {
                if (!response.ok) {
                    throw new Error('Failed to fetch data');
                }
            })
            ;
    
    }
 
    useEffect(() => {
        // Replace with your API endpoint
        

        const mytoken=sessionStorage.getItem('google_token');
        var apiUrl = 'https://app64.heliohost.us/api/getShareAlarms.php?orderby=symb';
        if (typeof orderby !== "undefined") {
            apiUrl = 'https://app64.heliohost.us/api/getShareAlarms.php?orderby=' + orderby;
        }
        //const apiUrl = 'http://localhost/api/getShareAlarms.php';

        
        fetch( apiUrl,{
            method:"GET",          
            headers:{
                "Content-Type": "application/json",
                "AuthCode" : mytoken
            }
        })
            .then((response) => {
                if (!response.ok) {
                    throw new Error('Failed to fetch data');
                }
                return response.json();
            })
            .then((data) => {
                setData(data);
                setLoading(false);
            })
            .catch((error) => {
                console.error("Error:", error);
                setError(error.message);
                setLoading(false);
            });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []); // Empty dependency array means this runs once on component mount

    if (loading) {
        return <p>Loading...</p>;
    }

    if (error) {
        return <p>Error: {error}</p>;
    }

    return (
        <div>
            <Menu/>
            <h1 className="page-title">Share Alarms</h1>
            <div>
                
                <div>
                <button type="button" onClick={updateProcentAut}>
                set default procent
                        </button>

                    
                </div>
            </div>

            <div className="table-container">
                <table className="data-table">
                    <thead>
                        <tr>
                            <th>ID</th>
                            <th onClick={() => handleSort('symb')} className={getSortClass('symb')}>Symbol</th>
                            <th>Val</th>
                            <th>Last Val</th>
                            <th>My Buy</th>
                            <th>Type Search</th>
                            <th>XTB Symb</th>
                            <th>Type Share</th>
                            <th onClick={() => handleSort('procent')} className={getSortClass('procent')}>%</th>
                            <th>Updated</th>
                            <th>Nr Shares</th>
                            <th onClick={() => handleSort('myprocbuy')} className={getSortClass('myprocbuy')}>% Buy</th>
                        </tr>
                    </thead>
                    <tbody>
                        {sortedData.map((item) => (
                            <tr key={item.id}>
                                <td><a href={`/sharealarmedit/${item.id}`}>{item.id}</a></td>
                                <td>{item.symb}</td>
                                <td>{item.val}</td>
                                <td>{item.lastval}</td>
                                <td>{item.myactbuy}</td>
                                <td>{item.typesearch}</td>
                                <td>{item.symbXTB}</td>
                                <td>{item.typeshare}</td>
                                <td>{item.procent}</td>
                                <td>{item.last_check}</td>
                                <td>{item.nrcmyshare}</td>
                                <td>{item.myprocbuy}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default ShareAlarms;
